import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { SnackbarComponent } from 'src/app/components/shared/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  openSnackBar(timeOpen: number, message: string, messageType: string, messageTitle?: string, extraInfo: boolean = true) {
    const conf = {
      data: {
        message: message,
        messageTitle: messageTitle,
        messageType: messageType,
        extraInfo
      },
      duration: timeOpen,
    };
    this.snackBar.openFromComponent(SnackbarComponent, conf);
  }
}
